export const buildEmailSubject = (report, rakennusData) => {
  return `${report?.name || "Raportti"}${
    rakennusData?.kohteen_nimi
      ? ` - ${rakennusData.kohteen_nimi}`
      : ""
  }`;
};

export const buildEmailBody = (meUser) => `Hei,

Liitteenä raportti.



${meUser?.nimi || ""}
${meUser?.puhelinnumero || ""}
${meUser?.sahkoposti || ""}

${meUser?.yritys || "Oy Waativa Ab"}
www.waativa.fi`;



